export const AuthLlibresSocialitzats = ({ auth, handleChange, error }) => {

    return (<>
        <div className="row">
            <div className="col col-12 ">
                <h4>
                    Llibres socialitzats
                </h4>
                <p>

                    <h5>La família/tutor/a legal declara que:</h5>
                    <ol>
                        <li>Ha rebut en préstec, per part del centre educatiu, un o diversos llibres de text o materials curriculars dins del programa de socialització de llibres.</li>
                        <li>Coneix que aquests llibres són propietat del centre o formen part d’un sistema de reutilització compartida, i per tant s’han de conservar en <b>bon estat</b> i retornar al final del curs.</li>
                        <li>Es compromet a:</li>
                        <ul>
                            <li>Vetllar pel <b>bon ús i conservació</b> del material prestat.</li>
                            <li>No <b>subratllar, escriure o pintar</b> als llibres.</li>
                            <li>Retornar tots els llibres en bon estat en la data indicada pel centre.</li>
                            <li><b>Reposar o abonar</b> el cost del llibre en cas de pèrdua o deteriorament greu per un ús inadequat.</li>
                        </ul>
                        <li>Entén que, en cas d’incompliment, podrà quedar <b>exclòs/a</b> del programa de reutilització de llibres en cursos posteriors.</li>
                    </ol>


                    <input type="checkbox" id="authLlibresSocialitzats" name="authLlibresSocialitzats" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
                    <label htmlFor="authLlibresSocialitzats"> He llegit i accepto les condicions</label>
                    <span id="auhtLlibresSocialitzats_ERROR" className="a-Form-error">{error}</span>
                </p>

            </div>
        </div>

        <br />
    </>)

}